export const CheckMarkIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="6" viewBox="0 0 8 6" fill="none">
      <path d="M2.99999 4.00002L1 2.00004L0 3.00003L2.99999 6L8 1.00001L7.00001 0L2.99999 4.00002Z" fill="#4F96FF" />
    </svg>
  );
};
